module.exports = __webpack_public_path__ + "img/sshx4.de14b460.png";